module.exports = __webpack_public_path__ + "static/media/duque_de_caxias.ac4758fe.png";